import { useMutation } from '@apollo/client';
import { useMemo } from 'react';
import { ThreadActions } from '../comments/CommentThread';
import {
  ADD_COMMENT_REPLY,
  DELETE_COMMENT,
  DELETE_COMMENT_REPLY,
  PIN_COMMENT,
  UPDATE_COMMENT,
  UPDATE_COMMENT_REPLY,
  UPDATE_STATUS,
} from './comment.graphql';

/** The guide comment mutations, in the shape the shared comment thread UI expects. */
export function useGuideCommentActions(): ThreadActions {
  const [deleteComment] = useMutation(DELETE_COMMENT);
  const [updateStatus] = useMutation(UPDATE_STATUS);
  const [pinComment] = useMutation(PIN_COMMENT);
  const [updateComment] = useMutation(UPDATE_COMMENT);
  const [createReply] = useMutation(ADD_COMMENT_REPLY);
  const [updateReply] = useMutation(UPDATE_COMMENT_REPLY);
  const [deleteReply] = useMutation(DELETE_COMMENT_REPLY);

  return useMemo<ThreadActions>(
    () => ({
      remove: (commentId) =>
        deleteComment({
          variables: { input: { commentId } },
          update(cache) {
            cache.evict({ id: cache.identify({ __typename: 'GuideCommentModel', id: commentId }) });
            cache.gc();
          },
        }),
      setStatus: (commentId, status) => updateStatus({ variables: { input: { commentId, status } } }),
      pin: (commentId, isPinned) => pinComment({ variables: { input: { commentId, isPinned } } }),
      update: (commentId, text) => updateComment({ variables: { input: { commentId, text } } }),
      createReply: (commentId, comment) => createReply({ variables: { input: { commentId, comment } } }),
      updateReply: (commentId, replyId, comment) => updateReply({ variables: { input: { commentId, replyId, comment } } }),
      deleteReply: (commentId, replyId) => deleteReply({ variables: { input: { commentId, replyId } } }),
    }),
    [deleteComment, updateStatus, pinComment, updateComment, createReply, updateReply, deleteReply],
  );
}
